import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LogoImage } from "./Logo";

const LINKS = [
  { label: "How It Works", href: "/#how-it-works", testid: "nav-link-how-it-works" },
  { label: "Service States", href: "/#service-states", testid: "nav-link-states" },
  { label: "Fixed vs Variable", href: "/#rates", testid: "nav-link-rates" },
  { label: "FAQ", href: "/#faq", testid: "nav-link-faq" },
  { label: "Blog", href: "/blog", route: true, testid: "nav-link-blog" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const NavItem = ({ l, mobile = false }) =>
    l.route ? (
      <Link
        to={l.href}
        onClick={() => setOpen(false)}
        data-testid={l.testid}
        className={mobile
          ? "block w-full text-left py-3 text-[15px] font-medium text-slate-700 border-b border-slate-100 last:border-0"
          : "text-sm font-medium text-slate-600 transition-colors hover:text-[#0066FF]"}
      >
        {l.label}
      </Link>
    ) : (
      <a
        href={l.href}
        onClick={() => setOpen(false)}
        data-testid={l.testid}
        className={mobile
          ? "block w-full text-left py-3 text-[15px] font-medium text-slate-700 border-b border-slate-100 last:border-0"
          : "text-sm font-medium text-slate-600 transition-colors hover:text-[#0066FF]"}
      >
        {l.label}
      </a>
    );

  return (
    <header
      className={`sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 transition-shadow duration-300 ${
        scrolled ? "shadow-sm" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <Link to="/" data-testid="navbar-brand-logo" aria-label="BlueSettle home" className="flex items-center">
            <LogoImage className="h-9 sm:h-10 w-auto" />
          </Link>

          <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
            {LINKS.map((l) => (
              <NavItem key={l.testid} l={l} />
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="/#get-quote"
              data-testid="nav-quote-btn"
              className="hidden sm:inline-flex items-center rounded-full bg-[#0066FF] hover:bg-[#0052CC] text-white text-sm font-semibold px-5 py-2.5 transition-colors shadow-[0_4px_14px_rgba(0,102,255,0.35)]"
            >
              Get My Rate Review
            </a>
            <button
              className="lg:hidden p-2 rounded-md text-[#0B1F44]"
              onClick={() => setOpen((o) => !o)}
              data-testid="nav-mobile-menu-btn"
              aria-label="Toggle menu"
            >
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100 px-4 pb-6 pt-2 shadow-lg">
          {LINKS.map((l) => (
            <NavItem key={l.testid} l={l} mobile />
          ))}
          <a
            href="/#get-quote"
            onClick={() => setOpen(false)}
            className="mt-3 block text-center w-full rounded-full bg-[#0066FF] text-white font-semibold py-3"
          >
            Get Custom Quote
          </a>
        </div>
      )}
    </header>
  );
}
